/* Fit Guide drawer ("the Ledger") — behaviour.
   Moved out of snippets/sidedrawer-fit-guide.liquid on 2026-09-09: it was 18,7xx characters of
   inline JS in every document, on a drawer most visitors never open. Loaded deferred from
   layout/theme.liquid after theme.js; a small parse-time bootstrap stays in the snippet because
   the portal and the inert flag must land before first paint (see the note there).
   ⚠ No Liquid may enter this file — it is a plain .js asset. Verified 0 tags at the move.
   ⚠ bin/check-fit-data.py parses the DATA and LABELS declarations out of this file with a regex.
   Keep both on one line each, in the shape they are in below, or the pre-push gate stops working.
   Owner: brisk-docs/docs/fit-guide-drawer.md
*/
  /* BRISK FIT GUIDE — scoped, idempotent, read-only toward the PDP option inputs. */
  (function () {
    'use strict';
    if (window.__bfgReady) return; window.__bfgReady = true;
    var root = document.getElementById('bfg');
    var drawer = document.getElementById('side-drawer');
    var closer = document.getElementById('close-drawer');
    if (!root || !drawer) return;

    /* Numbers carried over verbatim from sidedrawer-shirts-static.liquid (inches).
       [chest, waist, hips, sleeve, length] per collar bracket. */
    var DATA = {
      slim:    { '14':[39,36,37,33.25,28], '15':[42,39,40,33.75,29], '16':[45,42,43,34.75,30], '17':[48,45,46,35.25,31], '18':[51,48,49,35.75,31], '19':[54,51,52,36,31.5], '20':[57,54,55,36.5,32.5], '21':[59.5,56.5,57.5,37,33], '22':[61.5,58,59.5,37.5,33.5] },
      modern:  { '14':[40.5,37.5,38,33.25,28], '15':[43.5,40.5,41,33.75,29], '16':[46.5,43.5,44,34.75,30], '17':[49.5,46.5,47,35.25,31], '18':[52.5,49.5,50,35.75,31.5], '19':[55.5,52.5,53,36,32], '20':[58.5,55.5,56,36.5,32.5], '21':[61,58,58.5,37,33], '22':[63,61,61.5,37.5,33.5] },
      regular: { '14':[43,42,43,33.25,28], '15':[45,44,45,33.75,29], '16':[48,47,48,34.75,30], '17':[51,50,51,35.25,31], '18':[54,53,54,35.75,31.5], '19':[56,55,56,36,32], '20':[60,57.5,58,36.5,32.5], '21':[62,59.5,60,37,33], '22':[64,62,63,37.5,33.5] }
    };
    var KEYS = ['chest','waist','hips','sleeve','length'];
    var LABELS = { '14':'14 – 14.5','15':'15 – 15.5','16':'16 – 16.5','17':'17 – 17.5','18':'18 – 18.5','19':'19 – 19.5','20':'20','21':'21','22':'22' };
    var FITNAMES = { slim:'Slim', modern:'Modern', regular:'Regular' };
    var unit = 'in';

    function fmt(inches) {
      if (unit === 'cm') return Math.round(inches * 2.54) + '<small>cm</small>';
      return inches + '<small>in</small>';
    }
    function cv(inches) { return unit === 'cm' ? Math.round(inches * 2.54) : inches; }
    /* Collar labels follow the unit too (merchant 2026-08-20). Brackets 14-19 are
       ranges (c to c+0.5); 20-22 are single values — mirrors LABELS. */
    function collarLabel(c) {
      var base = parseFloat(c);
      if (base <= 19) return cv(base) + ' – ' + cv(base + 0.5);
      return String(cv(base));
    }
    function renderStats() {
      var fit = root.dataset.fit, collar = root.dataset.collar;
      var fn = root.querySelector('[data-bfg-fitname]'); if (fn) fn.textContent = FITNAMES[fit];
      var row = (DATA[fit] || {})[collar];
      var picked = !!row;
      /* honest empty state: no collar picked -> prompt copy + dashes, never a fake default */
      var np = root.querySelector('[data-bfg-note-pick]'); if (np) np.hidden = picked;
      var nc = root.querySelector('[data-bfg-note-collar]'); if (nc) nc.hidden = !picked;
      if (!picked) {
        KEYS.forEach(function (k) {
          var el = root.querySelector('[data-bfg-stat="' + k + '"]');
          if (el) el.innerHTML = '—';
        });
        return;
      }
      KEYS.forEach(function (k, i) {
        var el = root.querySelector('[data-bfg-stat="' + k + '"]');
        if (el) el.innerHTML = fmt(row[i]);
      });
      var cn = root.querySelector('[data-bfg-collarname]'); if (cn) cn.textContent = collarLabel(collar);
    }
    function setFit(fit, focusTarget) {
      if (!DATA[fit]) return;
      root.dataset.fit = fit;
      /* 2026-09-09 a11y: two controls drive one state and they are different widgets. The
         segmented control is the real tablist (aria-selected + roving tabindex, so only the
         selected tab is a tab stop); the chart's fit pills are toggle buttons, where
         aria-selected is invalid - they take aria-pressed, like the in/cm toggle beside them. */
      root.querySelectorAll('[data-bfg-fit]').forEach(function (b) {
        var on = b.dataset.bfgFit === fit;
        if (b.getAttribute('role') === 'tab') {
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        } else {
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      });
      root.querySelectorAll('[data-bfg-panel]').forEach(function (p) {
        p.hidden = p.dataset.bfgPanel !== fit;
      });
      /* the full chart shows exactly the selected fit's table */
      root.querySelectorAll('[data-bfg-table]').forEach(function (t) {
        t.hidden = t.dataset.bfgTable !== fit;
      });
      if (mediaOpened) loadFitPhoto(fit);
      renderStats();
      scrollHints();
      if (focusTarget) focusTarget.focus();
    }
    function setCollar(c) {
      if (!LABELS[c]) return;
      root.dataset.collar = c;
      root.querySelectorAll('[data-bfg-collar]').forEach(function (b) {
        if (b.dataset.bfgCollar === c) b.setAttribute('aria-pressed', 'true');
        else b.removeAttribute('aria-pressed');
      });
      /* highlight the shopper's collar row in the full chart (generated tables carry data-collar) */
      root.querySelectorAll('.bfg-full tr[data-collar]').forEach(function (tr) {
        tr.classList.toggle('is-you', tr.dataset.collar === c);
      });
      renderStats();
    }
    function setUnit(u) {
      unit = u;
      root.querySelectorAll('[data-bfg-unit]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.bfgUnit === u ? 'true' : 'false');
      });
      renderStats();
      /* full-chart tables: generated cells show bare numbers (unit lives in the note);
         metafield-blob cells keep a suffix because their surrounding text expects one */
      root.querySelectorAll('.bfg-full [data-in]').forEach(function (td) {
        var v = parseFloat(td.getAttribute('data-in'));
        var out = u === 'cm' ? Math.round(v * 2.54) : v;
        td.textContent = td.closest('[data-bfg-generated]') ? out : out + (u === 'cm' ? ' cm' : ' in');
      });
      /* collar labels convert too: the chips (same markup shape, so styling and
         aria-pressed survive) and the generated chart's Collar column */
      root.querySelectorAll('.bfg-collars [data-bfg-collar]').forEach(function (b) {
        var base = parseFloat(b.dataset.bfgCollar);
        b.innerHTML = base <= 19
          ? cv(base) + '<span>–' + cv(base + 0.5) + '</span>'
          : String(cv(base));
      });
      root.querySelectorAll('.bfg-full tr[data-collar] td:first-child').forEach(function (td) {
        td.textContent = collarLabel(td.parentElement.getAttribute('data-collar'));
      });
      scrollHints();
    }

    /* Chart scroll hints (merchant phone pass 2026-08-20): has-more paints the right-edge
       fade while columns hide to the right; is-scrolled drops a shadow off the frozen
       Collar column once the table has moved. Hoisted vars — safe to call before init. */
    var chartWrap = root.querySelector('[data-bfg-scrollwrap]');
    var chartScroller = root.querySelector('[data-bfg-scroller]');
    function scrollHints() {
      if (!chartWrap || !chartScroller) return;
      chartWrap.classList.toggle('is-scrolled', chartScroller.scrollLeft > 2);
      chartWrap.classList.toggle('has-more',
        chartScroller.scrollLeft + chartScroller.clientWidth < chartScroller.scrollWidth - 2);
    }
    if (chartScroller) {
      chartScroller.addEventListener('scroll', scrollHints, { passive: true });
      window.addEventListener('resize', scrollHints, { passive: true });
      var chartDetails = chartScroller.closest('details');
      if (chartDetails) chartDetails.addEventListener('toggle', scrollHints);
    }

    /* READ-ONLY preselect from the PDP's own chips. Never writes back. */
    function preselect() {
      try {
        var fitInput = document.querySelector('.option-selector[data-option-name="fit"] input.js-option:checked');
        if (fitInput) {
          var v = (fitInput.value || '').toLowerCase();
          if (DATA[v]) setFit(v);
        }
        var collarSel = document.querySelector('.option-selector[data-option-name="collar-size"] input.js-option:checked')
                     || document.querySelector('.option-selector[data-option-name="collar size"] input.js-option:checked');
        if (collarSel) {
          var num = Math.floor(parseFloat(collarSel.value));
          if (LABELS[String(num)]) setCollar(String(num));
        }
      } catch (e) { /* preselection is a nicety — never let it break the guide */ }
    }

    /* Build the full chart from DATA when there is no metafield table. */
    function buildFullChart() {
      var mount = root.querySelector('[data-bfg-generated]');
      if (!mount) { /* metafield mode: annotate its .size cells with data-in for the unit toggle */
        root.querySelectorAll('.bfg-full .size').forEach(function (td) {
          var v = parseFloat(td.textContent); if (!isNaN(v)) td.setAttribute('data-in', v);
        });
        return;
      }
      /* ONE table per fit, switched by the fit pills above (only the active fit's is shown) */
      var html = '';
      Object.keys(DATA).forEach(function (fit) {
        html += '<div data-bfg-table="' + fit + '"' + (fit === root.dataset.fit ? '' : ' hidden') + '><table><thead><tr><th scope="col">Collar</th><th scope="col">Chest</th><th scope="col">Waist</th><th scope="col">Hips</th><th scope="col">Sleeve</th><th scope="col">Length</th></tr></thead><tbody>';
        Object.keys(DATA[fit]).forEach(function (c) {
          /* bare numbers — the unit is stated ONCE (toggle + note), not 54 times (Rams) */
          html += '<tr data-collar="' + c + '"><td>' + LABELS[c] + '</td>';
          DATA[fit][c].forEach(function (v) { html += '<td data-in="' + v + '">' + v + '</td>'; });
          html += '</tr>';
        });
        html += '</tbody></table></div>';
      });
      mount.innerHTML = html;
    }

    /* Lazy media: nothing downloads until the drawer first opens, and then only the fit on
       screen. 2026-09-09: this used to load all THREE photos (~55 KB) on first open regardless of
       which fit was selected; the other two now arrive when the shopper actually switches to them.
       Not resized: the box is 118px (96 on phones) and the source is 360 wide, which is what a 3x
       phone asks for - going smaller would soften it, and going larger is banned (invariant #5). */
    var mediaOpened = false;
    function loadFitPhoto(fit) {
      var img = root.querySelector('[data-bfg-panel="' + fit + '"] img[data-bfg-src]');
      if (!img) return;
      img.src = img.getAttribute('data-bfg-src');
      img.removeAttribute('data-bfg-src');
    }
    function loadMedia() {
      mediaOpened = true;
      loadFitPhoto(root.dataset.fit);
    }
    /* 2026-09-09, merchant: "fit drawer images takes some time to load when I open the page."
       Measured cold on production: 167 ms unthrottled, 550 ms at ~1.6 Mbps/150 ms RTT - the photo
       only starts downloading on the click that opens the drawer. Start it on INTENT instead
       (hover or the first touch on anything that opens the guide), which is a few hundred ms
       earlier and costs a page-load nothing: still zero bytes until the shopper reaches for it. */
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (mediaOpened || !e.target || !e.target.closest) return;
        if (!e.target.closest('#open-drawer, [data-bnav-fitguide]')) return;
        loadFitPhoto(root.dataset.fit);
      }, { capture: true, passive: true });
    });

    /* Tablist keyboard (APG tabs): Left/Right wrap, Home/End jump, and moving focus activates -
       the panels are already in the DOM, so activation costs nothing. Delegated from the document
       for the same reason the click handler is: a theme-editor re-render replaces #bfg. */
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('#bfg')) return;
      if (t.getAttribute && t.getAttribute('role') !== 'tab') return;
      var step = { ArrowLeft: -1, ArrowRight: 1, Home: 'first', End: 'last' };
      if (!Object.prototype.hasOwnProperty.call(step, e.key)) return;
      var list = t.closest('[role="tablist"]');
      if (!list) return;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      var i = tabs.indexOf(t), next;
      if (step[e.key] === 'first') next = tabs[0];
      else if (step[e.key] === 'last') next = tabs[tabs.length - 1];
      else next = tabs[(i + step[e.key] + tabs.length) % tabs.length];
      if (!next || !next.dataset.bfgFit) return;
      e.preventDefault();
      setFit(next.dataset.bfgFit, next);
    });

    /* Delegated clicks inside the guide. */
    /* 2026-09-09 QA: this used to bind to `root`. A theme-editor section re-render replaces #bfg,
       and the listener stayed on the detached old node — measured: after a re-render the fit pills
       and the unit toggle did nothing. Delegating from the document survives any number of
       re-renders and leaks no listeners on detached nodes. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('#bfg')) return;
      var t = e.target.closest('[data-bfg-fit], [data-bfg-collar], [data-bfg-unit], [data-bfg-route]');
      if (!t) return;
      if (t.dataset.bfgFit) setFit(t.dataset.bfgFit);
      else if (t.dataset.bfgCollar) setCollar(t.dataset.bfgCollar);
      else if (t.dataset.bfgUnit) setUnit(t.dataset.bfgUnit);
      else if (t.dataset.bfgRoute) {
        if (closer) closer.click();
        if (t.dataset.bfgRoute === 'wair') {
          var w = document.querySelector('.predict-placement button');
          if (w) setTimeout(function () { w.click(); }, 320);
        } else {
          /* FitSure lives inside BOTH custom-size flows: the OCS modal (fitSure__form) and
             the DYS builder (Size FitSure step). Route to whichever this page has. */
          var ocs = document.querySelector('[data-bs-target="#order_custom_size_modal_trigger"], [data-bs-target="#design_your_shirt_modal_trigger"]');
          if (ocs) setTimeout(function () { ocs.click(); }, 320);
        }
      }
    });

    /* Section nav: smooth-scroll inside the drawer + scrollspy. */
    var content = drawer.querySelector('.drawer-content');
    root.querySelectorAll('[data-bfg-nav]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = root.querySelector(a.getAttribute('href'));
        if (target && content) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          /* 104 = sticky header (56) + sticky nav (~46) */
          content.scrollTo({ top: target.offsetTop - 104, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });
    if (content) {
      var secs = Array.prototype.slice.call(root.querySelectorAll('.bfg-sec[id]'));
      var ticking = false;
      content.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var pos = content.scrollTop + 120, current = secs[0];
          secs.forEach(function (s) { if (s.offsetTop <= pos) current = s; });
          /* bottom clamp (merchant phone pass 2026-08-20): the last section is shorter
             than the viewport, so scrollTop maxes out BEFORE its offsetTop crosses the
             threshold — Measure could never activate. At the end of travel, the last
             section is what the shopper is looking at, so it wins. */
          if (content.scrollTop + content.clientHeight >= content.scrollHeight - 4) {
            current = secs[secs.length - 1];
          }
          root.querySelectorAll('[data-bfg-nav]').forEach(function (a) {
            a.classList.toggle('is-active', current && a.getAttribute('href') === '#' + current.id);
          });
        });
      }, { passive: true });
    }

    /* Routes: only show what exists on this page (fail-toward-hidden — these are extras). */
    if (document.querySelector('.predict-placement') && !document.querySelector('.fgt-no-wair')) {
      var rw = root.querySelector('[data-bfg-route="wair"]'); if (rw) rw.hidden = false;
    }
    /* FitSure PAUSED per merchant 2026-08-19 — to re-enable, flip this to true AND remove the
       if-false Liquid wrapper around the button markup above. (⚠ invariant #13: never write a
       literal Liquid tag in ANY comment, JS comments included — Liquid parses it for real; the
       first version of this comment did exactly that and Shopify silently rejected the file.) */
    var BFG_FITSURE_ENABLED = false;
    if (BFG_FITSURE_ENABLED && document.querySelector('[data-bs-target="#order_custom_size_modal_trigger"], [data-bs-target="#design_your_shirt_modal_trigger"]')) {
      var rf = root.querySelector('[data-bfg-route="fitsure"]'); if (rf) rf.hidden = false;
    }

    /* 🚨 PORTAL THE DRAWER TO <body> (2026-08-19, caught live by the merchant). The drawer is
       authored deep inside the section markup, where an ancestor stacking context TRAPS its
       z-index:9999 — at root level it painted BELOW the body-level scrim (9998), so the scrim
       grayed the drawer and swallowed every real click. elementFromPoint proved it: the scrim
       won at every coordinate. JS .click() bypasses hit-testing, which is why scripted QA
       passed. Moving the node preserves identity, so theme.js's #open-drawer/#close-drawer/
       outside-click handlers keep working. Re-run on shopify:section:load for the editor. */
    function portal() {
      var el = document.getElementById('side-drawer');
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
      return el;
    }
    drawer = portal();
    /* Theme editor: a section re-render authors a FRESH drawer while the stale portaled
       one is still a body child (duplicate ids, dead theme.js bindings — QA 0a-19 M4).
       Retire the stale node, adopt the fresh one, rebind and rebuild. */
    document.addEventListener('shopify:section:load', function () {
      var fresh = Array.prototype.filter.call(document.querySelectorAll('#side-drawer'), function (el) { return el !== drawer; })[0];
      if (!fresh) { drawer = portal(); return; }
      if (drawer && drawer.parentElement === document.body) drawer.remove();
      drawer = portal();
      root = document.getElementById('bfg');
      closer = document.getElementById('close-drawer');
      obs.disconnect(); obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      setDialogState(drawer.classList.contains('open'));
      /* 2026-09-09 QA: the fresh drawer may be a jeans/chinos/pique one, which has no #bfg.
         Everything below reads it — measured: a TypeError on the re-render without this guard. */
      if (!root) return;
      drawer.setAttribute('aria-labelledby', 'bfg-title');
      /* re-resolve the nodes cached at init, or the scroll hints point at detached elements */
      chartWrap = root.querySelector('[data-bfg-scrollwrap]');
      chartScroller = root.querySelector('[data-bfg-scroller]');
      if (chartScroller) chartScroller.addEventListener('scroll', scrollHints, { passive: true });
      buildFullChart(); setCollar(root.dataset.collar); renderStats();
    });

    /* Dialog semantics live only WHILE OPEN (a permanently-present aria-modal dialog
       misleads AT, and the closed off-canvas drawer must not be tabbable — QA 0a-19 M3).
       inert removes the closed drawer from tab order and the a11y tree. */
    function setDialogState(open) {
      if (open) {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.removeAttribute('inert');
      } else {
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
        drawer.setAttribute('inert', '');
      }
    }
    drawer.setAttribute('aria-labelledby', 'bfg-title');
    setDialogState(drawer.classList.contains('open'));
    /* Delegated open/close: idempotent beside theme.js's own bindings, and the only
       working pair after an editor re-render replaces the buttons theme.js bound. */
    document.addEventListener('click', function (e) {
      if (!drawer) return;
      if (e.target.closest('#open-drawer') && !drawer.classList.contains('open')) {
        drawer.classList.add('open'); document.body.classList.add('body-no-scroll');
      } else if (e.target.closest('#close-drawer') && drawer.classList.contains('open')) {
        drawer.classList.remove('open'); document.body.classList.remove('body-no-scroll');
      }
    });
    var scrim = document.createElement('div');
    scrim.className = 'bfg-scrim'; scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
    scrim.addEventListener('click', function () { if (closer) closer.click(); });

    var lastFocus = null;
    var preselected = false; /* once per page: reopening must not revert the shopper's picks */
    function onOpenChange() {
      var open = drawer.classList.contains('open');
      scrim.classList.toggle('is-on', open);
      setDialogState(open);
      if (open) {
        lastFocus = document.activeElement;
        loadMedia();
        if (!preselected) { preselect(); preselected = true; }
        if (closer) closer.focus();
      } else if (lastFocus && document.contains(lastFocus) && lastFocus.offsetParent !== null) {
        /* offsetParent check: never restore focus into a hidden container (e.g. the
           closed mobile nav drawer after the pill handoff) */
        lastFocus.focus(); lastFocus = null;
      } else { lastFocus = null; }
    }
    var obs = new MutationObserver(onOpenChange);
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('open')) return;
      if (e.key === 'Escape') { if (closer) closer.click(); return; }
      if (e.key !== 'Tab') return;
      /* 2026-09-09 QA: inputs/selects/textareas were missing, so a form control inside the guide
         would have fallen outside the trap. */
      var focusables = drawer.querySelectorAll('button, a[href], summary, iframe, input:not([type="hidden"]), select, textarea, [contenteditable], [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null || el === closer; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    buildFullChart();
    setCollar(root.dataset.collar); /* paints the is-you row into the freshly built chart */
    renderStats();
  })();
